const ROOT = "pollsViewer";
const PRESET_SELECTOR_MODAL = "presetSelectorModal";
const TEXT_LIST_OPTION = "textListOption";
const IMAGE_AND_LIST_OPTION = "imageAndListOption";
const IMAGE_GRID_OPTION = "imageGridOption";
const POLLS_MULTIPLE_ANSWER_TEXT = "pollsMultipleAnswerText";
const POLLS_QUESTION_IMAGE = "pollsQuestionImage";
const POLLS_ANSWER_IMAGE = "pollsAnswerImage";
const POLLS_ANSWER_ITEMS = "pollsAnswerItems";
const POLLS_QUESTION_TEXT_INPUT = "pollsQuestionTextInput";
const POLLS_ANSWER_TEXT_INPUT = "pollsAnswerTextInput";
const POLLS_ADD_ANSWER_BUTTON = "pollsAddAnswerItemButton";
const POLLS_REMOVE_ANSWER_BUTTON = "pollsRemoveAnswerItemButton";
const POLLS_ITEM_PERCENTAGE_PREVIEW = "pollsItemsPercentagePreview";
const POLLS_DROPDOWN_CUSTOMIZE_LAYOUT = "poll_layout_modal_button";
const POLLS_SETTINGS_MODAL = "polls-settings";
const POLLS_SETTINGS_TABS = "polls-settings-tabs";
const POLLS_SETTINGS_LAYOUT_TAB = "polls-layout-tab";
const POLLS_SETTINGS_DESIGN_TAB = "polls-design-tab";
const POLLS_SETTINGS_SETTINGS_TAB = "polls-settings-tab";
const POLLS_IMAGE_TO_QUESTION_TOGGLE = "pollsImageToQuestionToggle";
const POLLS_IMAGE_TO_ANSWERS_TOGGLE = "pollsImageToAnswersToggle";
const POLL_LAYOUT_LIST = "pollsLayoutList";
const POLL_LAYOUT_GRID = "pollsLayoutGrid";
const POLL_DIRECTION_LTR = "pollsDirectionLTR";
const POLL_DIRECTION_RTL = "pollsDirectionRTL";
const POLL_BACKGROUND_COLOR = "pollsDesignBackgroundColor";
const POLL_BACKGROUND_COLOR_PICKER = "pollsDesignBackgroundColorPicker";
const POLL_BACKGROUND_GRADIENT = "pollsDesignBackgroundGradient";
const POLL_BACKGROUND_IMAGE = "pollsDesignBackgroundImage";
const POLL_CORDER_RADIUS_SLIDER = "pollsDesignBorderRadiusSlider";
const POLL_CORDER_RADIUS_INPUT = "pollsDesignBorderRadiusInput";
const ANSWERS_CORNER_RADIUS_SLIDER = "pollsDesignAnswersCornerRadiusSlider";
const ANSWERS_CORNER_RADIUS_INPUT = "pollsDesignAnswersCornerRadiusInput";
const POLLS_MULTIPLE_ANSWERS_TOGGLE = "pollsMultipleAnswersToggle";
const POLLS_VOTE_COUNT_TOGGLE = "pollsVoteCountToggle";
const POLLS_EACH_PERSON_VOTE_TOGGLE = "pollsEachPersonVoteToggle";
const POLL_VISIBILITY_OPTION_EVERYONE = "pollsVisibilityResultEveryone";
const POLL_VISIBILITY_OPTION_VOTERS = "pollsVisibilityResultVoters";
const POLL_VISIBILITY_OPTION_CREATOR = "pollsVisibilityResultCreator";

export { ANSWERS_CORNER_RADIUS_INPUT, ANSWERS_CORNER_RADIUS_SLIDER, IMAGE_AND_LIST_OPTION, IMAGE_GRID_OPTION, POLLS_ADD_ANSWER_BUTTON, POLLS_ANSWER_IMAGE, POLLS_ANSWER_ITEMS, POLLS_ANSWER_TEXT_INPUT, POLLS_DROPDOWN_CUSTOMIZE_LAYOUT, POLLS_EACH_PERSON_VOTE_TOGGLE, POLLS_IMAGE_TO_ANSWERS_TOGGLE, POLLS_IMAGE_TO_QUESTION_TOGGLE, POLLS_ITEM_PERCENTAGE_PREVIEW, POLLS_MULTIPLE_ANSWERS_TOGGLE, POLLS_MULTIPLE_ANSWER_TEXT, POLLS_QUESTION_IMAGE, POLLS_QUESTION_TEXT_INPUT, POLLS_REMOVE_ANSWER_BUTTON, POLLS_SETTINGS_DESIGN_TAB, POLLS_SETTINGS_LAYOUT_TAB, POLLS_SETTINGS_MODAL, POLLS_SETTINGS_SETTINGS_TAB, POLLS_SETTINGS_TABS, POLLS_VOTE_COUNT_TOGGLE, POLL_BACKGROUND_COLOR, POLL_BACKGROUND_COLOR_PICKER, POLL_BACKGROUND_GRADIENT, POLL_BACKGROUND_IMAGE, POLL_CORDER_RADIUS_INPUT, POLL_CORDER_RADIUS_SLIDER, POLL_DIRECTION_LTR, POLL_DIRECTION_RTL, POLL_LAYOUT_GRID, POLL_LAYOUT_LIST, POLL_VISIBILITY_OPTION_CREATOR, POLL_VISIBILITY_OPTION_EVERYONE, POLL_VISIBILITY_OPTION_VOTERS, PRESET_SELECTOR_MODAL, ROOT, TEXT_LIST_OPTION };
//# sourceMappingURL=dataHooks.js.map
